// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3NxM2","label":"Completed_label__1fLL_"};